/** Instagram camera glyph (lucide v1 dropped brand icons). Inherits currentColor. */
export function IgGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5.5" stroke="currentColor" strokeWidth="1.9" />
      <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.9" />
      <circle cx="17.3" cy="6.7" r="1.2" fill="currentColor" />
    </svg>
  );
}

/** Puzzle-piece-free "extension" glyph: a browser window with a plug dot. */
export function ExtensionGlyph({ size = 18, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2.5" y="4" width="19" height="16" rx="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M2.5 8.5h19" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="5.6" cy="6.25" r=".9" fill="currentColor" />
      <circle cx="8.4" cy="6.25" r=".9" fill="currentColor" />
      <path d="M9 14.5h6M12 11.5v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
